import ReactApexChart from "react-apexcharts";
import React from "react";

const findMax = (arr) => {
  return Math.max(...arr);
};
class RadialBarChart extends React.Component {
  constructor(props) {
    super(props);
    // let max=findMax(this.props.db)
    let max = Math.max(...this.props.db);
    max = Math.ceil(max);

    this.state = {
      series: this.props.db.map((ele) => {
        return (ele * 100) / max;
      }),

      options: {
        yaxis: {
          // min: 4500,
          // max: 5000
        },

        scales: {
          y: {
            max: 445,
            min: 0,

            ticks: {
              stepSize: 0.5,
            },
          },
        },

        axisY: {
          //     minimum: 50,
          maximum: 480,
        },

        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 200,
                stepSize: 10,
              },
            },
          ],
        },

        chart: {
          height: 300,
          type: this.props.type,
          max: 200,

          // scales: {
          //   y: {
          //     suggestedMin: 0,
          //     suggestedMax: 69,
          //   },
          //   x: {
          //     suggestedMin: 0,
          //     suggestedMax: 420,
          //   },
          // },
        },

        // scales:{
        //   min:0,
        //   max:1500,
        // },

        plotOptions: {
          radialBar: {
            offsetY: 0,

            startAngle: 0,
            endAngle: 270,

            hollow: {
              margin: 0,
              size: "1%",
              background: "transparent",
              image: undefined,
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                // show: true,
                formatter: this.props.db.map((val) => (val * this.max) / 100),
              },
            },
          },
        },
        colors: this.props.color,
        labels: this.props.labels,
        legend: {
          show: true,
          floating: true,
          fontSize: "10px",
          position: "left",
          offsetX: 100,
          offsetY: 15,

          labels: {
            useSeriesColors: true,
          },

          markers: {
            size: 0,
          },
          formatter: function (seriesName, opts) {
            return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex];
          },
          itemMargin: {
            vertical: 3,
          },
        },
        responsive: [
          {
            breakpoint: 0,
            options: {
              legend: {
                show: false,
              },
            },
          },
        ],
      },
    };
  }

  render() {
    return (
      <div id="chart">
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="radialBar"
          height={390}
        />
      </div>
    );
  }
}
export default RadialBarChart;
